import gql from 'graphql-tag'

import { SchoolListingFieldsFragment } from 'main/gql/schoolListing'

export const CalloutSchoolListingFieldsFragment = gql`
  fragment CalloutSchoolListingFields on SchoolListing {
    ...SchoolListingFields
    profile {
      id
      enrollment
      hoursStart
      hoursEnd
      philosophy
      networkRating
      whitelabelRating {
        label
        slug
        symbolCount
      }
    }
  }

  ${SchoolListingFieldsFragment}
`
